import PropTypes from "prop-types";
import { Input, Modal, ModalBody } from "reactstrap";
import "./vouchersModal.scss";
import CLoseImg from "../../../assets/images/closeIconModal.svg";
import { useState } from "react";
import send from "../../../assets/images/sendIcon.png";

const VouchersModal = ({
  show,
  onDeleteClick,
  onCloseClick,
  voucherData,
  handleSendOrder,
}: any) => {
  const [activeTab, setActiveTab] = useState("customer");

  return (
    <Modal
      isOpen={show}
      toggle={onCloseClick}
      centered={true}
      className="VoucherModal"
    >
      <img
        data-testing-id="closeIcon"
        onClick={onCloseClick}
        className="closeIconModal"
        src={CLoseImg}
        alt=""
      />
      <ModalBody className="VoucherBody">
        <div className="headingDv">
          <h2>Vouchers</h2>
          {/* <h3>
            <span>
              <i className="bx bx-plus-medical"></i>
            </span>
            Create Vouchers
          </h3> */}
        </div>
        {voucherData &&
          voucherData.map((voucher: any, index: number) => (
            <div className="voucherCardDv">
              <div className="firstChild">
                <h4>{voucher?.promotionName}</h4>
                {voucher.flatAmount > 0 && (
                  <h2>Rs {voucher?.flatAmount} OFF</h2>
                )}
                {voucher.discountPercentage > 0 && (
                  <h2>{voucher?.discountPercentage} %OFF</h2>
                )}
                <h3>on travel accessories!</h3>
              </div>
              <div className="secondChild">
                <div
                  className="sendBtn"
                  onClick={() => handleSendOrder(voucher)}
                  data-testing-id={"sendVoucher" + index}
                >
                  Send <img src={send} alt="" />
                </div>
                <h3>Valid until </h3>
                <h3>
                  {new Date(voucher?.createdOn).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })}
                </h3>
              </div>
            </div>
          ))}
      </ModalBody>
    </Modal>
  );
};

VouchersModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
  handleSendOrder: PropTypes.func,
  voucherData: PropTypes.any,
};

export default VouchersModal;
